import { render, staticRenderFns } from "./TeamPortalPromotion.vue?vue&type=template&id=6f9b267a&scoped=true&"
import script from "./TeamPortalPromotion.vue?vue&type=script&lang=js&"
export * from "./TeamPortalPromotion.vue?vue&type=script&lang=js&"
import style0 from "./TeamPortalPromotion.vue?vue&type=style&index=0&id=6f9b267a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9b267a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9b267a')) {
      api.createRecord('6f9b267a', component.options)
    } else {
      api.reload('6f9b267a', component.options)
    }
    module.hot.accept("./TeamPortalPromotion.vue?vue&type=template&id=6f9b267a&scoped=true&", function () {
      api.rerender('6f9b267a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamPortalPromotion.vue"
export default component.exports